import type { RouteRecordRaw } from 'vue-router'

import { ensureRootRoutePath, type RedirectRoutePath } from '@/utilities/routers'

const routeTwoFactorSetupName = '/qrcode'
const routeTwoFactorSetupPath = ensureRootRoutePath(routeTwoFactorSetupName)

const routeTwoFactorSetup: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/TwoFactorSetupView.vue')
  },
  meta: {
    requireAuth: false,
  },
  name: routeTwoFactorSetupName,
  path: routeTwoFactorSetupPath,
}

const redirectTwoFactorSetup: RedirectRoutePath = {
  // use no "name" attribute here, not working with global navigationGuard
  path: routeTwoFactorSetup.path,
}

export { redirectTwoFactorSetup, routeTwoFactorSetup }
